// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"6d2ec8a7","158":"2a486b12","564":"d2ca088e","604":"5a6f36dd","702":"b9d835e3","796":"3d3341d0","809":"5eb68dbc","987":"28e525c5"}[chunkId] + ".chunk.css";
};